import type { CSSProperties } from 'styled-components'

import { sanitize } from '@hozana/utils/functions/objects'

export const mergeStyles = (currentStyle: CSSProperties, newStyle: CSSProperties) => ({
  ...currentStyle,
  ...sanitize(newStyle),
})
